import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicServerPowerShutdownParamsRawI,
	LWApiPublicServerPowerShutdownResultRawI,
} from '@liquidweb-dev/club-sauce/public/server/power.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { NOTIFICATIONS_CURRENT_QUERY_KEY } from 'modules/queries/notification/useCurrent';
import useInvalidateAssets from 'modules/queries/invalidateQueries/useInvalidateAssets';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useServerShutdown = () => {
	const snackbarError = useSnackbarError();
	const invalidateAssets = useInvalidateAssets();
	const queryClient = useQueryClient();
	return useMutation<
		LWApiPublicServerPowerShutdownResultRawI,
		ApiErrorI,
		LWApiPublicServerPowerShutdownParamsRawI
	>({
		mutationFn: (params) => api.server.power.apiRaw.shutdown(params),
		onSuccess: (_data, params) => {
			invalidateAssets(params.uniq_id);

			queryClient.invalidateQueries({
				queryKey: [NOTIFICATIONS_CURRENT_QUERY_KEY],
			});
		},
		onError: snackbarError,
	});
};

export default useServerShutdown;
